import {Injectable} from "@angular/core";
import {EventTracker, EventTrackerMethodName, GlobalTrackingEventService} from "fello-common";

@Injectable()
export class OfferFlowTrackingEventService extends GlobalTrackingEventService {
  private trackingEnabled = true;

  enableTracking(): void {
    this.trackingEnabled = true;
  }

  disabledTracking(): void {
    this.trackingEnabled = false;
  }

  protected dispatchToTrackers<K extends EventTrackerMethodName>(method: K, ...args: Parameters<EventTracker[K]>) {
    if (this.trackingEnabled) {
      super.dispatchToTrackers(method, ...args);
    }
  }
}
